import { appFeedsRoute } from 'lib/constants/routes'
export const getSignUpAndSignInDefaultRedirectPath = (showWebappEntryPoint: boolean) => {
    if (showWebappEntryPoint) {
        return appFeedsRoute
    }
    return '/'
}
